import React, { useContext } from "react";
import { FormikErrors, FormikTouched } from "formik";
import { TestSpecificationSearchMultipleAutocomplete } from "../../../../components/Autocomplete/CustomSearchAutoComplete.instances";
import InfoBox from "../../../../components/InfoBox";
import ConfirmationDialogContext from "../../../../components/Dialog/ConfirmationDialog/ConfirmationDialogContext";
import TesaTmbApi from "../../../../api/services/TesaTmbApi";
import DescriptionFormType from "../models/Description.form";

const infoText =
  "Indicate the name of the specifications or standards which need to be executed for this test request.";

export interface TestSpecificationInputProps {
  disabled: boolean;
  errors: FormikErrors<DescriptionFormType>;
  handleDirtyChange: () => void;
  mandatory?: boolean;
  setFieldValue: (field: string, value: unknown, shouldValidate?: boolean) => void;
  touched: FormikTouched<DescriptionFormType>;
  values: DescriptionFormType;
}

function TestSpecificationInput(props: TestSpecificationInputProps) {
  const { disabled, errors, handleDirtyChange, mandatory, touched, setFieldValue, values } = props;
  const dialogContext = useContext(ConfirmationDialogContext);
  const tesaTmbApi = new TesaTmbApi(dialogContext);

  const helperText = errors.specifications && touched.specifications ? errors.specifications : "";
  return (
    <InfoBox text={infoText}>
      <TestSpecificationSearchMultipleAutocomplete
        disabled={disabled}
        mandatory={mandatory}
        error={!!(errors.specifications && touched.specifications)}
        helperText={typeof helperText === "string" ? helperText : undefined}
        inputLabel="Customer Specifications or Standards"
        placeholder="Add Specification"
        map={(value): { key: string; label: string } => ({
          key: `${value.testPlanVersionId || value.testPlanVersionName}`,
          label: `${value.testPlanVersionName}`,
        })}
        onChange={(event, newSpecifications): void => {
          const lastItem = newSpecifications[newSpecifications.length - 1];
          if (
            newSpecifications.length <= (values.specifications || []).length ||
            !(values.specifications || []).some((spec) => spec.testPlanVersionName === lastItem.testPlanVersionName)
          ) {
            setFieldValue("specifications", newSpecifications);
            handleDirtyChange();
          }
        }}
        optionFetch={(query) =>
          tesaTmbApi.searchTestSpecificationVersions(query, 50).then((pagedSpecifications) => ({
            ...pagedSpecifications,
            data: pagedSpecifications.data.map((specification) => ({
              testPlanVersionId: specification.id,
              testPlanVersionName: specification.name,
              testPlanVersionVersion: specification.version,
            })),
          }))
        }
        value={values.specifications || []}
      />
    </InfoBox>
  );
}

export default TestSpecificationInput;
